import { DonorListSort } from 'gql/types';
import { Sorter } from 'modules/common/components';
import { useSort } from 'modules/common/hooks';
import { options } from 'modules/donor/components/GroupDonorCardList/GroupDonorCardListSorter/options';
import { FC } from 'react';

const useDonorListSort = () => useSort<DonorListSort>();

type PropTypes = {
  sorting: ReturnType<typeof useDonorListSort>;
};

export const GroupDonorCardListSorter: FC<PropTypes> = ({ sorting }) => (
  <Sorter sorting={sorting as ReturnType<typeof useSort>} options={options} />
);
